/* eslint-disable @typescript-eslint/naming-convention */
export type LiveEditorStep = number;

export type LiveEditorStepKey =
  | "title"
  | "date"
  | "location"
  | "fundraising-goal"
  | "description"
  | "color"
  | "banner"
  | "logo"
  | "smart-anchor-amount"
  | "suggested-donation-amounts"
  | "tickets"
  | "questions"
  | "add-donation"
  | "tax-receipts"
  | "discount-codes"
  | "collaborators"
  | "business-model"
  | "e-ticket"
  | "thank-you-email"
  | "thank-you-email-fundraiser"
  | "thank-you-email-not-winner"
  | "advanced-settings"
  | "review"
  | "p2p-settings";

// Do not use this to get the order
const nonOrderedLiveEditorStepsKeys: LiveEditorStepKey[] = [
  "title",
  "date",
  "location",
  "color",
  "banner",
  "description",
  "logo",
  "smart-anchor-amount",
  "suggested-donation-amounts",
  "tickets",
  "questions",
  "add-donation",
  "discount-codes",
  "collaborators",
  "thank-you-email",
  "thank-you-email-fundraiser",
  "thank-you-email-not-winner",
  "advanced-settings",
  "e-ticket",
  "review",
  "fundraising-goal",
  "tax-receipts",
  "business-model",
  "p2p-settings",
];

export const isValidStepKey = (key: unknown, hasUserManagementPermission: boolean): key is LiveEditorStepKey => {
  if (key === "collaborators" && !hasUserManagementPermission) {
    return false;
  }

  return typeof key === "string" && nonOrderedLiveEditorStepsKeys.includes(key as LiveEditorStepKey);
};
